import { useProctorRequestListSearchParams } from '../../hooks';
import { DraftProctorRequestList } from '../draft-proctor-request-list';
import { InReviewProctorRequestList } from '../in-review-proctor-request-list';
import { RejectedProctorRequestList } from '../rejected-proctor-request-list';

export default function ProctorRequestList() {
  const [{ status }] = useProctorRequestListSearchParams();

  switch (status) {
    case 'IN_REVIEW':
      return <InReviewProctorRequestList />;
    case 'REJECTED':
      return <RejectedProctorRequestList />;
    case 'DRAFT':
      return <DraftProctorRequestList />;
    default:
      return null;
  }
}
